<div class="modal-header">
  <h5 class="modal-title" i18n>Set Visibility</h5>
  <button (click)="close()" type="button" class="close">
    <i class="fas fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <div *ngIf="loading" class="d-flex flex-row justify-content-center">
    <mat-spinner matSuffix diameter="16"></mat-spinner>
  </div>

  <div *ngIf="!loading && isVisible" class="d-flex flex-column align-items-stretch gap-3">
    <app-select-search
      [inline]="false"
      [items]="parent?.choices"
      bindValue="value"
      bindLabel="description"
      [ctrl]="form.get('parentId')"
      [multiple]="false"
      [placeholder]="parent?.description"
      [required]="true"
    ></app-select-search>

    <app-select-search
      [inline]="false"
      [items]="selectedParent?.choices"
      bindValue="value"
      bindLabel="description"
      [ctrl]="form.get('childId')"
      [multiple]="false"
      [placeholder]="selectedParent?.description"
      *ngIf="selectedParent?.choices?.length"
      [required]="true"
    ></app-select-search>

    <mat-form-field2 *ngIf="isDetailRequired" class="mat-block">
      <input matInput placeholder="Details" i18n-placeholder [formControl]="form.get('details')" required />
    </mat-form-field2>
  </div>

  <div *ngIf="!loading && !isVisible">
    <ng-container i18n>This listing is currently </ng-container><b i18n>not visible</b>.
    <ng-container i18n>Would you like to make it visible?</ng-container>
  </div>
</div>
<div class="modal-footer">
  <button *ngIf="!submitting" (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>

  <mat-spinner *ngIf="submitting" matSuffix diameter="16"></mat-spinner>

  <button
    *ngIf="!loading"
    [disabled]="submitting"
    (click)="setVisibility(form)"
    type="button"
    class="btn btn-secondary-info text-uppercase create-btn"
  >
    <i class="far fa-check"></i>
    <ng-container i18n *ngIf="isVisible">Hide</ng-container>
    <ng-container i18n *ngIf="!isVisible">Set visible</ng-container>
  </button>
</div>
